import React from 'react';
import { Box, Button, Stack, Tooltip, Typography } from '@mui/material';
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';

interface NameIgnoreCTAProps {
  count: number;
  onIgnore: () => void;
}

// Surfaces on "Потребують уваги" — proper-name candidates (uppercase first
// letter heuristic). One click bulk-moves them into the ignore list.
// When the BE returns words lowercased, the heuristic finds nothing — the
// button stays disabled with a tooltip, which is honest signal.
const NameIgnoreCTA: React.FC<NameIgnoreCTAProps> = ({ count, onIgnore }) => {
  const disabled = count === 0;
  const button = (
    <Button
      startIcon={<PersonOffOutlinedIcon />}
      onClick={onIgnore}
      disabled={disabled}
      size={'small'}
    >
      {disabled ? 'Додати імена в ігнор' : `Додати імена в ігнор (${count})`}
    </Button>
  );

  return (
    <Box
      sx={(theme) => ({
        bgcolor:
          theme.palette.mode === 'dark'
            ? 'rgba(155,124,255,0.05)'
            : 'rgba(59,44,147,0.03)',
        border: `1px solid ${
          theme.palette.mode === 'dark'
            ? '#303A48'
            : theme.palette.primary.tableBorder
        }`,
        borderRadius: 2,
        px: 2,
        py: 1.25,
      })}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent={'space-between'}
        spacing={1.25}
      >
        <Stack direction={'row'} spacing={1.5} alignItems={'center'}>
          <PersonOffOutlinedIcon sx={{ color: 'text.secondary' }} />
          <Box>
            <Typography fontWeight={700} variant={'body2'}>
              {'Власні імена'}
            </Typography>
            <Typography variant={'caption'} color={'text.secondary'}>
              {
                'Слова, що починаються з великої літери — найімовірніше це імена персонажів, які вчити не варто.'
              }
            </Typography>
          </Box>
        </Stack>
        {disabled ? (
          <Tooltip
            arrow
            placement={'top'}
            title={'У цій вкладці немає слів, що схожі на імена.'}
          >
            <span>{button}</span>
          </Tooltip>
        ) : (
          button
        )}
      </Stack>
    </Box>
  );
};

export default NameIgnoreCTA;
